(function () {
    'use strict';

    angular.module("imApp").factory("deliveryMethodServicesService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 2659,
                    parameters: parms || {}
                });
            },
            listServices: function (parms) {
                return $ihttp.post({
                    method: 2656,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
